"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Select_1 = __importDefault(require("@material-ui/core/Select"));
var core_1 = require("@material-ui/core");
var __1 = require("..");
var classnames_1 = __importDefault(require("classnames"));
exports.default = react_1.forwardRef(function Select(_a, ref) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, label = _a.label, onChange = _a.onChange, options = _a.options, selectProps = __rest(_a, ["variant", "label", "onChange", "options"]);
    var classes = useStyles();
    var _d = react_1.useState(120), labelWidth = _d[0], setLabelWidth = _d[1];
    var inputLabel = react_1.useRef(null);
    react_1.useEffect(function () { var _a; return setLabelWidth(((_a = inputLabel === null || inputLabel === void 0 ? void 0 : inputLabel.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0); }, [inputLabel]);
    var renderOptions = function () { return options === null || options === void 0 ? void 0 : options.map(function (_a) {
        var value = _a.value, label = _a.label, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
        return (jsx_runtime_1.jsx(core_1.MenuItem, __assign({ value: value, disabled: disabled }, { children: label || value }), value));
    }); };
    var handleChange = function (event) {
        var _a = event.target, value = _a.value, name = _a.name;
        onChange === null || onChange === void 0 ? void 0 : onChange(value, name, event);
    };
    return (jsx_runtime_1.jsxs(__1.FormControl, __assign({ variant: variant, className: classes.wrapper }, { children: [Boolean(label) && (jsx_runtime_1.jsx(core_1.InputLabel, __assign({ htmlFor: label, ref: inputLabel }, { children: label }), void 0)),
            jsx_runtime_1.jsx(Select_1.default, __assign({}, selectProps, { onChange: handleChange, classes: { filled: classnames_1.default((_b = {}, _b[classes.filled] = Boolean(label) === false, _b)) }, labelWidth: labelWidth, disableUnderline: variant === 'filled', ref: ref }, { children: renderOptions() }), void 0)] }), void 0));
});
var useStyles = core_1.makeStyles(function (theme) { return ({
    wrapper: {
        minWidth: 200,
        '& .MuiFilledInput-root': {
            borderRadius: theme.shape.borderRadius + "px",
        },
    },
    filled: {
        paddingTop: theme.spacing(2.3),
        paddingBottom: theme.spacing(2.34),
        '&.MuiFilledInput-inputMarginDense': {
            paddingTop: theme.spacing(1.8),
            paddingBottom: theme.spacing(1.8),
        },
    },
}); });
//# sourceMappingURL=Select.js.map